module.exports = __webpack_public_path__ + "img/wechat.28cde736.png";